import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'

export const indexedPublicationsWToZ: readonly IndexedPublicationsSection[] = [
  {
    letter: 'W',
    references: [
      '@bib{RN2276};',
      '@bib{waerzeggers2014marduk};',
      '@bib{waetzoldt1976hallo};',
      '@bib{Waetzoldt2023FSMaul};',
      '@bib{wagensonner2024unchain};',
      '@bib{RN2604aa};',
      '@bib{CT0052};',
      '@bib{Walker1984Shamshi-Adad};',
      '@bib{walker2005astronomical};',
      '@bib{RN778}; ',
      '@bib{wallenfels2014latebabylonian};',
      '@bib{wallenfels2014late}; ',
      '@bib{RN3091};',
      '@bib{wasserman2022akkadian};',
      '@bib{RN545a}; ',
      '@bib{Watson1991Stone};',
      '@bib{RN3242av};',
      '@bib{WeiHru2018};',
      '@bib{KAL11};',
      '@bib{YOS_17};',
      '@bib{CUSAS_26};',
      '@bib{NABU2017-87};',
      '@bib{NABU2017-88};',
      '@bib{NABU2017-89};',
      '@bib{UBHD-1553948}; ',
      '@bib{UBHD-1553949};',
      '@bib{UBHD-1553950};',
      '@bib{wiseman1953alalakh}; ',
      '@bib{wiseman1954supplementary};',
      '@bib{Worthington2003JMC2K19766};',
      '@bib{Worthington2003JMC2propositions};',
      '@bib{RN1266};',
      '@bib{RN3131};',
      '@bib{Wunsch1993A};',
      '@bib{Wunsch1993B}; ',
      '@bib{Wunsch1997Neu};',
      '@bib{wunsch1997richter};',
      '@bib{wunschEgibiArchivFelderUnd2000};',
      '@bib{wunsch2003urkunden};',
      '@bib{RN2083ax}',
    ],
  },
  {
    letter: 'Z',
    references: [
      '@bib{zadok1997late-babylonian};',
      '@bib{Zand2023FSMaul};',
      '@bib{Zawadzki1985Foundry};',
      '@bib{zawadzkiGarmentsGodsVol2006};',
      '@bib{zawadzki2024dubsar};',
      '@bib{RN637};',
      '@bib{Ziegler2005JMC5};',
      '@bib{Ziegler2023FSMaul};',
      '@bib{RN1693};',
      '@bib{VS_2};',
      '@bib{VS_10};',
      '@bib{zisa2022the};',
      '@bib{zólyomi2003manuscript};',
      '@bib{NABU2006-65};',
      '@bib{RN635};',
      '@bib{NABU2024-50};',
      '@bib{zólyomi2025sumerian};',
      '@bib{RN3006ax};',
      '@bib{Zomer2023Hymn}',
    ],
  },
]
